import styled from 'styled-components';
import React from 'react';

import {modalAppearanceSetup} from '../modal-condition/modalAppearanceSetup';
import {ColorTheme} from '../../../shared-components/variables/feature-colors/ColorTheme';
import FocusTrap from '../../../shared-components/FocusTrap';

export const ModalContainer = ({children, show, size, closing, footer, popup, isPopupModal}) => (
    <ColorTheme>
        {popup && (
            <FocusTrap>
                <PopupContainer show={show} footer={footer} size={size} closing={closing}>
                    {children}
                </PopupContainer>
            </FocusTrap>
        )}

        {!popup && (
            <ModalAsideContainer isPopupModal={isPopupModal} footer={footer}>
                {children}
            </ModalAsideContainer>
        )}
    </ColorTheme>
);

const Wrapper = styled.div`
    --modal-padding: 20px;
    --modal-body-padding-bottom: 40px;
    --modal-padding-footer-top: 8px;
    --modal-border-radius: 10px;
    --modal-default-width: calc(100% - var(--modal-padding));

    --modal-dropdown-list-height: 120px;
    --modal-gimmick-bar-height: 7px;
    --modal-title-text-size: 16px;
    --modal-title-label-size: 14px;

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;

    ${({isPopupModal}) => {
        if (isPopupModal)
            return `
            position: unset;
        `;
    }}
`;

const PopupContainer = styled(Wrapper)`
    overflow: hidden;
    outline: 0;
    height: 100%;
    display: block;
    ${({show}) => modalAppearanceSetup(show)};
`;

export const ModalAsideContainer = styled(Wrapper)`
    --sidebar-width: 400px;
    pointer-events: none;
`;
